import { _ as _asyncToGenerator, a as _regeneratorRuntime, b as _objectSpread2 } from './useInternalQuery-8432b378.esm.js';
import { dehydrate, useMutation } from '@tanstack/react-query';
import { d as defaultQueryClient, b as _typeof } from './client-19c3a323.esm.js';
import { pick } from 'livepeer';
import { useMemo } from 'react';
import { Q as QueryClientContext } from './context-dc86cecf.esm.js';

function prefetchQuery(_x) {
  return _prefetchQuery.apply(this, arguments);
}
function _prefetchQuery() {
  _prefetchQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
    var client, dehydratedState;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            client = defaultQueryClient();
            _context.next = 4;
            return client.prefetchQuery(options);
          case 4:
            dehydratedState = dehydrate(client);
            if (options !== null && options !== void 0 && options.clearClient) {
              client.clear();
            }
            return _context.abrupt("return", dehydratedState);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            console.warn(_context.t0);
            return _context.abrupt("return", {
              mutations: [],
              queries: []
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));
  return _prefetchQuery.apply(this, arguments);
}

var useInternalMutationKeys = ['cacheTime', 'networkMode', 'onError', 'onMutate', 'onSettled', 'onSuccess', 'retry', 'retryDelay', 'useErrorBoundary', 'meta'];
function useInternalMutation(options, mutationFn, mutationKey) {
  var _useMutation = useMutation(mutationFn, _objectSpread2(_objectSpread2({
      context: QueryClientContext,
      mutationKey: mutationKey
    }, _typeof(options === null || options === void 0 ? void 0 : options.mutationConfig) === 'object' ? pick(options.mutationConfig, useInternalMutationKeys) : {}), {}, {
      useErrorBoundary: false
    })),
    data = _useMutation.data,
    error = _useMutation.error,
    isError = _useMutation.isError,
    isIdle = _useMutation.isIdle,
    isLoading = _useMutation.isLoading,
    isSuccess = _useMutation.isSuccess,
    mutate = _useMutation.mutate,
    _mutateAsync = _useMutation.mutateAsync,
    reset = _useMutation.reset,
    variables = _useMutation.variables,
    status = _useMutation.status;
  return useMemo(function () {
    return {
      data: data,
      error: error,
      isError: isError,
      isIdle: isIdle,
      isLoading: isLoading,
      isSuccess: isSuccess,
      mutate: options ? function () {
        return mutate(_objectSpread2(_objectSpread2({}, options), {}, {
          config: undefined
        }));
      } : undefined,
      mutateAsync: function mutateAsync() {
        return options ? _mutateAsync(_objectSpread2(_objectSpread2({}, options), {}, {
          config: undefined
        })) : undefined;
      },
      variables: variables,
      status: status,
      internal: {
        reset: reset
      }
    };
  }, [data, error, isError, isIdle, isLoading, isSuccess, mutate, _mutateAsync, reset, variables, status, options]);
}

export { useInternalMutationKeys as a, prefetchQuery as p, useInternalMutation as u };
